import { z } from 'zod';

export const AiCareDocumentGenerateSchema = z.object({
  appointmentIds: z.array(z.string().min(1)).min(1),
  documentsPaths: z.array(z.string().min(1)).optional(),
  prompt: z.string().nullish(),
});

export type AiCareDocumentGenerate = z.infer<
  typeof AiCareDocumentGenerateSchema
>;
